import { useMemo } from "react";
import { useAuth } from "../../auth/hooks";
import { extractDomainFromEmail } from "../../../lib/utils";

export interface UserInfo {
  email: string;
  organization: string;
  joinDate?: string; // Will be fetched from API when available
}

export function useUserInfo() {
  const { userEmail, isLoading: authLoading } = useAuth();

  const userInfo = useMemo<UserInfo | null>(() => {
    if (!userEmail) {
      return null;
    }

    const domain = extractDomainFromEmail(userEmail);
    return {
      email: userEmail,
      organization: domain || "Unknown",
      // TODO: Fetch join date from API when available
      joinDate: undefined,
    };
  }, [userEmail]);

  return { userInfo, isLoading: authLoading };
}

